import { 
    // 取得房東列表
    apiBizGetLandlordMgtList,
    // 取得房東資料
    apiBizGetLandlordInfo,
    // 新增房東
    apiBizInsertLandlord,
    // 刪除房東
    apiBizDelLandlord,
} from "@/apis/api.js"; 
import { 
    // 上傳房東簽名
    uploadSignature
} from "@/apis/company/landlorgMgt.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_landlord_list: 'landlordMgt/set_landlord_list',
    set_landlord_info: 'landlordMgt/set_landlord_info',
    set_landlord_filter_word: 'landlordMgt/set_landlord_filter_word',
    set_landlord_signature: 'landlordMgt/set_landlord_signature',
    set_landlord_info_default: 'landlordMgt/set_landlord_info_default',
}

// count state 必須是 Object
const state = {
    landlordList: [],
    lanlordInfo: [],
    landlordSignature: null,
    filter: {
        word: null,
        options: {

        }
    }
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_LANDLORD_LIST: (state) => {
        return state.landlordList
    },
    GET_BIZ_LANDLORD_INFO: (state) => {
        return state.lanlordInfo
    },
    GET_BIZ_LANDLORD_FILTER_WORD: (state) => {
        return state.filter.word
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    // 取得帳號列表
    getBizLandlordList ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizGetLandlordMgtList()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if( res.data.result.length > 0){
                        commit(types.set_landlord_list, res.data.result);
                        resolve()
                    }
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 取得單一帳號
    getBizLanlordInfo ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            apiBizGetLandlordInfo(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_landlord_info, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 新增帳號
    insertBizLandlord ( {commit,dispatch} , value ) {
        return new Promise((resolve, reject) => {
            apiBizInsertLandlord(value)
            .then(res => {
                console.log(res)
                if(state.landlordSignature){
                    dispatch('saveBizLandlordSignature', res.data.result.landlordId)
                    .then(()=>{
                        resolve(res)
                    })
                }else{
                    resolve(res)
                }

                
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 刪除帳號
    delBizLandlord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiBizDelLandlord(value)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    resolve(res)
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    // 設定搜尋文字
    setlBizLandlordFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_landlord_filter_word, value);
            
        })
    },
    saveBizLandlordSignature ( {commit, state, dispatch}, id ) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let landlordId = id,
            signature = state.landlordSignature
            console.log(landlordId)
            formData.append('landlordId', landlordId);
            formData.append('signature', signature);
        
            uploadSignature(formData)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    resolve()
                }else{
                    dispatch('setLoadingState', 0)
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizLandlordSignature( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_landlord_signature, data);
        })
    },
    setBizLandlordInfoDefault( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_landlord_info_default, data);
        })
    },
}

// mutations
const mutations = {
    [types.set_landlord_list](state, data){
        state.landlordList = data
    },
    [types.set_landlord_info](state, data){
        state.lanlordInfo = data
    },
    [types.set_landlord_filter_word](state, data){
        state.filter.word = data
    },
    [types.set_landlord_signature](state, data){
        state.landlordSignature = data
    },
    [types.set_landlord_info_default](state, data){
        state.lanlordInfo = []
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/landlordMgt/landlordMgt.js